/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_RAPIDBOARDS_RESOURCE } from './resourceTypeRapidboardsWrmBundle.constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rapidboardResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_RAPIDBOARDS_RESOURCE,
	getKey: ({ match }) => match.query.rapidView || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-rapidboards-rapidboard-resource-data", jiraSpaEntry: "async-resource-rapidboards-rapidboard-resource-data" */ './RapidBoardResourceType.tsx'
		),
	maxAge: Number.MAX_VALUE,
	isBrowserOnly: true,
});
